import { IMAGE_PATHS } from 'constants/imagePaths';
import React from 'react';
import { Button } from 'react-bootstrap';
import './styles.scss';

interface AddMoreButtonProps {
	title?: string;
	slug?: string;
}

const AddMoreButton: React.FC<AddMoreButtonProps> = ({ title = '', slug = '' }) => {
	return (
		<Button
			className="add-experience-btn border-0 d-flex align-items-center rounded-pill"
			type="submit"
		>
			<i className="ri-add-circle-fill me-2"></i> {title}
		</Button>
	);
};

export default AddMoreButton;
